import Badge from '@pelckmans/elementis/components/badge';
import Pill from '@pelckmans/elementis/components/pill';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { Module } from '../../../../api/module';
import { fetchTocNodes, type Node } from '../../../../api/table-of-content';
import { getDescriptionOfNode } from '../../../../utils/getNodeDescription';
/*
 * The exerciseModuleCard renders the top level nodes in the subModuleSelector
 */
export default function ExerciseModuleNodeTags({ module }: { module: Module }) {
  const { t } = useTranslation();
  const [nodes, setNodes] = useState<Node[]>([]);

  useEffect(() => {
    const getTocNodes = async () => {
      const { data: tocNodes } = await fetchTocNodes(module.id, false, false);

      setNodes(tocNodes.map(node => ({ ...node, description: getDescriptionOfNode(node, t) })));
    };
    if (module) getTocNodes();
  }, [module, t]);

  if (nodes.length === 0) return null;

  return nodes.map(node => {
    const badgeProps = node.nodes && node.nodes.length > 0 ? { badge: <Badge>{node.nodes.length}</Badge> } : {};

    return (
      <Pill role="listitem" key={node.id} {...badgeProps}>
        {node.description}
      </Pill>
    );
  });
}
